"use client";

import { useContext } from "react";
import { TrackEventContext } from "./context";
export function useTrackEvent() {
  const {
    trackEvent
  } = useContext(TrackEventContext);
  return trackEvent;
}